const match = (a, b, operation) => {
  switch (operation) {
    case '=': return a === b;
    case '!=': return a !== b;
    case '<=': return a <= b;
    case '>=': return a >= b;
    case '>': return a > b;
    case '<': return a < b;
    default: throw new Error(`Operation '${operation}' is not a valid operation!`);
  }
};

const matchProperty = (condition, properties) => {
  if (!properties || !Object.keys(properties).length) {
    return false;
  }

  return match(condition.value, properties[condition.property], condition.operation);
};

const matchEntityProperty = (condition, entity) => {
  if (
    !entity
    || !entity.properties
    || !Object.keys(entity.properties).length
  ) {
    return false;
  }

  return match(condition.value, entity.properties[condition.property], condition.operation);
};

const matchFieldProperty = (condition, field) => {
  if (
    !field
    || !field.properties
    || !Object.keys(field.properties).length
  ) {
    return false;
  }

  return match(condition.value, field.properties[condition.property], condition.operation);
};

const matchFieldRelation = (condition, field) => {
  if (
    !field
    || !field.properties
    || !Object.keys(field.relation).length
  ) {
    return false;
  }

  return match(condition.value, field.relation[condition.property], condition.operation);
};

export default {
  namespaced: true,

  getters: {
    matches() {
      return (condition, properties, entity, field) => {
        if (!condition || !condition.type) {
          return true;
        }

        switch (condition.type) {
          case 'PROPERTY': return matchProperty(condition, properties);
          case 'ENTITY_PROPERTY': return matchEntityProperty(condition, entity);
          case 'FIELD_PROPERTY': return matchFieldProperty(condition, field);
          case 'FIELD_RELATION': return matchFieldRelation(condition, field);
          default: return false;
        }
      };
    },
  },
};
